import Vue from 'vue'
import Router from "vue-router";

import {authUser} from "../firebase"

import Body from '../components/body'
import auth from "../auth/auth"
import loginPage from "../auth/loginPage"
import forgotPassword from "../auth/forgotPassword"
import Register from '../auth/register'

/* maintenance */
import Maintenance from '../pages/maintenance'

/* Error Pages */
import Error400 from '../errors/error_400'
import Error401 from '../errors/error_401'
import Error403 from '../errors/error_403'
import Error404 from '../errors/error_404'
import Error500 from '../errors/error_500'
import Error503 from '../errors/error_503'

/* comingsoon */
import ComingsoonSimple from '../pages/comingsoon/comingsoon_simple'
import ComingsoonImage from '../pages/comingsoon/comingsoon_image'
import ComingsoonVideo from '../pages/comingsoon/comingsoon_video'

/* Procee */
import Lucking from "../pages/process/lucking.vue"
import RefillOL from '../pages/process/refillOL'
import RefillCC from '../pages/process/refillCC'
import AdjustBal from '../pages/process/adjustBal'
import ForecastHalfMthly from '../pages/process/forecastHalfMthly'
import ImportCSV from "../pages/process/importCSV"
/* Resources */
import Calendar from '../pages/resource/calendar'

import User from '../pages/resource/user'
import CreateUserAdmin from '../pages/resource/createUserAdmin'
import CreateUserHost from '../pages/resource/createUserHost'

/* Info */
import TermCondition from '../pages/info/termCondition'
/* Report */

import WalletReport from '../pages/report/walletReport'
import RefillSlip from '../pages/report/refillSlip.vue'
/* Widgets */

/* User Profile */
import UserEditProfile from '../pages/users/edit-profile'



// component

Vue.use(Router)

const routes = [
  { path: '', redirect: { name: 'login' }},
// { path: '', redirect: { name: 'Matching' }},
// { path: '', redirect: { name: '' }},
  {
    path:'/auth',
    component:auth,
    children:[
      {
        path:'login',
        name: 'login',
        component:loginPage
      },
      {
        path:'forgotPassword',
        name: 'forgotPassword',
        component:forgotPassword
      },
      {
        path: 'register',
        name: 'register',
        component: Register,
        meta: {
          title: ' Register | Hor-th - Premium Matching Empty Contsiner Platform',
        }
      },
    ]
  },
  {
    path: '/process',
    component: Body,
    children: [
      {
        path: 'lucking',
        name: 'lucking',
        component: Lucking,
        meta: {
          title: 'Lucking-Member',
          requiresAuth: true 
        }
      },
      {
        path: 'refillOL',
        name: 'refillOL',
        component: RefillOL,
        meta: {
          title: 'REFILL-Online',
        }
      },
      {
        path: 'refillCC',
        name: 'refillCC',
        component: RefillCC,
        meta: {
          title: 'REFILL-Cash Coupon',
        }
      },
      {
        path: 'adjustBal',
        name: 'adjustBal',
        component: AdjustBal,
        meta: {
          title: 'Adjust-Balanced Amount',
        }
      },
      {
        path: 'forecastHalfMthly',
        name: 'forecastHalfMthly',
        component: ForecastHalfMthly,
        meta: {
          title: 'FORECAST Half Monthly',
        }
      },
      {
        path:'importCSV',
        name: 'importCSV',
        component: ImportCSV,
        title: 'IMPORT CSV',
      },
    ]
  },
  {
    path: '/resource',
    component: Body,
    children: [
    {
      path: 'user',
      name: 'user',
      component: User,
      meta: {
        title: 'User Information',
      }
    },
    {
      path: 'createUserAdmin',
      name: 'createUserAdmin',
      component: CreateUserAdmin,
      meta: {
        title: 'Create New User - Admin',
      }
    },
    {
      path: 'createUserHost',
      name: 'createUserHost',
      component: CreateUserHost,
      meta: {
        title: 'Create New User - Host',
      }
    },
    {
      path: 'calendar',
      name: 'calendar',
      component: Calendar,
      meta: {
        title: 'Calender',
      }
    },
    ]
  },
  {
    path: '/report',
    component: Body,
    children: [
    {
      path: 'refillSlip',
      name: 'refillSlip',
      component: RefillSlip,
      meta: {
        title: 'Refill Slip Report',
      }
    },
    {
      path: 'walletReport',
      name: 'walletReport',
      component: WalletReport,
      meta: {
        title: 'Wallet Report',
      }
    },
    ]
  },
  {
    path: '/info',
    component: Body,
    children: [
    {
      path: 'termCondition',
      name: 'termCondition',
      component: TermCondition,
      meta: {
        title: 'Terms & Conditions',
      }
    },
    ]
  },
  {
    path:'/users',
    component: Body,
    children:[
      {
        path: 'edit',
        name: 'UserEditProfile',
        component:UserEditProfile,
        meta: {
          title: 'UserEditProfile | Hor-th - Premium Horasart-Thai',
        }
      }
    ]
  },
  {
    path:'/error-400',
    name:'Error400',
    component:Error400,
    meta: {
        title: 'Error400 | Hor-th - Premium Horasart-Thai',
      }
  },
  {
    path:'/error-401',
    name:'Error401',
    component:Error401,
    meta: {
        title: 'Error401 | Hor-th - Premium Horasart-Thai',
      }
  },
  {
    path:'/error-403',
    name:'Error403',
    component:Error403,
    meta: {
        title: 'Error403 | Hor-th - Premium Horasart-Thai',
      }
  },
  {
    path:'/error-404',
    name:'Error404',
    component:Error404,
    meta: {
        title: 'Error404 | Hor-th - Premium Horasart-Thai',
      }
  },
  {
    path:'/error-500',
    name:'Error500',
    component:Error500,
    meta: {
        title: 'Error500 | Hor-th - Premium Horasart-Thai',
      }
  },
  {
    path:'/error-503',
    name:'Error503',
    component:Error503,
    meta: {
        title: 'Error503 | Hor-th - Premium Horasart-Thai',
      }
  },
  {
    path:'/maintenance',
    name:'Maintenance',
    component:Maintenance,
    meta: {
        title: 'Maintenance | Hor-th - Premium Horasart-Thai',
      }
  },
  {
    path:'/comingsoon/comingsoon-simple',
    name:'ComingsoonSimple',
    component:ComingsoonSimple,
    meta: {
        title: 'ComingsoonSimple | Hor-th - Premium Horasart-Thai',
      }
  },
  {
    path:'/comingsoon/comingsoon-image',
    name:'ComingsoonImage',
    component:ComingsoonImage,
    meta: {
        title: 'ComingsoonImage | Hor-th - Premium Horasart-Thai',
      }
  },
  {
    path:'/comingsoon/comingsoon-video',
    name:'ComingsoonVideo',
    component:ComingsoonVideo,
    meta: {
        title: 'ComingsoonVideo | Hor-th - Premium Horasart-Thai',
      }
  }
];

const router = new Router({
  routes,
  base: '/horVue/',
  mode: 'history',
  linkActiveClass: "active",
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
});

// Navigation Guard
router.beforeEach((to, from, next) => {
  authUser.onAuthStateChanged((user) => {
    if(to.meta.title)
    document.title = to.meta.title;
    const CurrentUser = authUser.currentUser;
    const path = ['/auth/login','/auth/register', '/auth/clickLucking'];
    // const path = ['/auth/login','/auth/register', '/auth/importCSV'];
    if (path.includes(to.path) || to.path === "/callback" || CurrentUser ){
    return next();
    }
    next('/auth/login');

    // const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    // const currentUser = authUser.currentUser;
  
    // if (requiresAuth && !currentUser) {
    //   next('/auth/login');
    // } else if (!requiresAuth && currentUser && to.name === 'Login') {
    //   // next('/dashboard'); // Prevent authenticated users from seeing the login page
    //   next('/auth/register');
    // } else {
    //   next();
    // }

  });
});

export default router
